export const AuthServerApiBase = "/auth/api";
export const TromanWebApiBase = "/ginger.api/troman";
export const ValmanWebApiBase = "/ginger.api/valman";
export const AccountServiceBase = "/auth/api";
